import type { NewslettersConfig } from '@/types/ocelotConfig/utils';

export type NewsletterOption = NewslettersConfig[string] & { id: string };

export const getAvailableNewsletters = (
  config: NewslettersConfig | undefined,
  isUserLoggedIn: boolean,
): NewsletterOption[] =>
  Object.entries(config || {})
    .map(([id, newsletter]) => ({ id, ...newsletter }))
    .filter(({ requiresLogin }) => isUserLoggedIn || !requiresLogin);
